import React, { useContext } from 'react';
import styled from 'styled-components';

import AuthContext from '../../contexts/AuthContext';
import { buttonBackground } from '../../styles/colors';
import { Item, LinkItem } from '../Navigation';

const Dropdown = styled.div`
  z-index: 999;
  position: absolute;
  width: 300px;
  right: 10px;
  top: 80px;
  background-color: white;
  border: 1px solid ${buttonBackground};
  border-radius: 6px;
  padding: 12px;

  @media (max-width: 768px) {
    top: 180px;
  }
`;

const AccountMenu = ({ hide }) => {
  const { ownerPortalUsers, updateOwnerPortalUserId } = useContext(AuthContext);

  return (
    <Dropdown>
      {1 !== ownerPortalUsers.length && (
        <Item
          onClick={() => updateOwnerPortalUserId(null)}
          style={{cursor: 'pointer'}}
        >
          Switch FBO
        </Item>
      )}

      <LinkItem to="/account" onClick={hide}>
        Update Account/Password
      </LinkItem>
    </Dropdown>
  );
};

export default AccountMenu;
